module.exports = __webpack_public_path__ + "static/media/attach.df46a52d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attach.svg
// module id = 2065
// module chunks = 0